import { natural } from './compare';

export const sortNatural = (arr: Array<String>) => [].concat(arr).sort(natural);

export default {
  sortNatural
};
